import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ApartmentEditFormProps {
	street: string;
	onStreetChange: (value: string) => void;
	apartmentNumber: string;
	onApartmentNumberChange: (value: string) => void;
	coldWaterRate: string;
	onColdWaterRateChange: (value: string) => void;
	hotWaterRate: string;
	onHotWaterRateChange: (value: string) => void;
	heatRate: string;
	onHeatRateChange: (value: string) => void;
	consumptionRate: string;
	onConsumptionRateChange: (value: string) => void;
	hideElectricity: boolean;
}

export function ApartmentEditForm({
	street,
	onStreetChange,
	apartmentNumber,
	onApartmentNumberChange,
	coldWaterRate,
	onColdWaterRateChange,
	hotWaterRate,
	onHotWaterRateChange,
	heatRate,
	onHeatRateChange,
	consumptionRate,
	onConsumptionRateChange,
	hideElectricity,
}: ApartmentEditFormProps) {
	return (
		<>
			<div className="flex flex-col gap-1.5">
				<Label>Ulica</Label>
				<Input
					value={street}
					onChange={(e) => onStreetChange(e.target.value)}
				/>
			</div>
			<div className="flex flex-col gap-1.5">
				<Label>Numer lokalu</Label>
				<Input
					value={apartmentNumber}
					onChange={(e) => onApartmentNumberChange(e.target.value)}
				/>
			</div>
			<div className="flex flex-col gap-1.5">
				<Label>Woda zimna (zł/m³)</Label>
				<Input
					type="number"
					min="0"
					step="0.01"
					value={coldWaterRate}
					onChange={(e) => onColdWaterRateChange(e.target.value)}
				/>
			</div>
			<div className="flex flex-col gap-1.5">
				<Label>Woda ciepła (zł/m³)</Label>
				<Input
					type="number"
					min="0"
					step="0.01"
					value={hotWaterRate}
					onChange={(e) => onHotWaterRateChange(e.target.value)}
				/>
			</div>
			<div className="flex flex-col gap-1.5">
				<Label>Ciepło (zł/GJ)</Label>
				<Input
					type="number"
					min="0"
					step="0.01"
					value={heatRate}
					onChange={(e) => onHeatRateChange(e.target.value)}
				/>
			</div>
			{!hideElectricity && (
				<div className="flex flex-col gap-1.5">
					<Label>Energia (zł/kWh)</Label>
					<Input
						type="number"
						min="0"
						step="0.01"
						value={consumptionRate}
						onChange={(e) => onConsumptionRateChange(e.target.value)}
					/>
				</div>
			)}
		</>
	);
}
